import { Reveal, SectionHeader } from "./Reveal";
import { useLang } from "@/context/LanguageContext";

const ICONS = ["fa-magnifying-glass-chart", "fa-cubes", "fa-user-gear"];

export default function Lifecycle() {
  const { t } = useLang();
  return (
    <section id="lifecycle" className="border-y border-white/10 bg-navy/30 py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeader eyebrow={t.lifecycle.eyebrow} title={t.lifecycle.title} sub={t.lifecycle.sub} />

        <div className="relative mt-14 grid gap-6 lg:grid-cols-3">
          <div className="absolute left-0 right-0 top-10 hidden border-t border-dashed border-white/15 lg:block" />
          {t.lifecycle.steps.map((s, i) => (
            <Reveal
              key={i}
              delay={i * 0.12}
              className="relative border border-white/10 bg-deep p-8 transition-colors hover:border-steel/40"
              testid={`lifecycle-step-${i}`}
            >
              <div className="flex items-center justify-between">
                <span className="font-mono text-sm text-crimson">/{s.step}</span>
                <i className={`fa-solid ${ICONS[i]} text-2xl text-steel`} />
              </div>
              <h3 className="mt-8 font-display text-2xl font-semibold uppercase leading-tight text-white">
                {s.title}
              </h3>
              <p className="mt-4 text-[15px] leading-relaxed text-slate-400">{s.desc}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
